import { useState } from 'react';

export default function IntroScreen({ title, body, onClose }) {
  const [dontShow, setDontShow] = useState(false);

  return (
    <div className="intro-overlay">
      <div className="intro-modal">
        {title && <h1 className="intro-title">{title}</h1>}
        {body && (
          <div
            className="intro-body"
            // Content is authored by the admin in the settings panel — treat as trusted HTML
            dangerouslySetInnerHTML={{ __html: body }} // eslint-disable-line react/no-danger
          />
        )}
        <div className="intro-footer">
          <label className="intro-dismiss-label">
            <input
              type="checkbox"
              checked={dontShow}
              onChange={e => setDontShow(e.target.checked)}
            />
            Do not show this again
          </label>
          <button className="intro-cta btn-primary" onClick={() => onClose(dontShow)}>
            Explore Outcomes →
          </button>
        </div>
      </div>
    </div>
  );
}
